import {useMediaQuery} from "react-responsive"

import {token} from "@styled-system/tokens"

export const useIsDesktop = (): boolean =>
  useMediaQuery({
    query: `(min-width: ${token("breakpoints.largeDesktop")})`,
  })
